import { Descriptions, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import CopyButton from '@/components/common/CopyButton';
import type { PayoutFailureDetail } from '@/api/payouts';

const { Text } = Typography;

/**
 * 上游返回的失败原文。**给研发看的**，所以不翻译、不美化，原样展示 Airwallex 回的
 * 状态码、错误码与出错字段路径，并给一个复制按钮 —— 排查时直接贴进 issue。
 *
 * 🔴 这里只有后端白名单挑过的字段（payouts.service.ts 的 applyRejection），
 * 不含任何账号值。
 *
 * 抽成组件是因为它有两个入口：打款记录列表那一格的「查看上游原文」弹窗，以及
 * 记录详情抽屉里的失败那一段。同一份失败在两处必须显示成同一句话。
 */
export default function FailureDetailView({
  detail,
  payoutId,
  shortReferenceId,
}: {
  detail: PayoutFailureDetail;
  payoutId: string;
  shortReferenceId: string | null;
}) {
  return (
    <>
      <Descriptions column={1} size="small" bordered style={{ marginBottom: 12 }}>
        <Descriptions.Item label="HTTP 状态">{detail.upstreamStatus}</Descriptions.Item>
        <Descriptions.Item label="Airwallex 错误码">{detail.upstreamCode ?? '—'}</Descriptions.Item>
        <Descriptions.Item label="说明">{detail.message}</Descriptions.Item>
        <Descriptions.Item label="出错字段">
          {detail.fields.length > 0 ? (
            <Space direction="vertical" size={0}>
              {detail.fields.map((f) => (
                <Text key={f} code style={{ fontSize: 12 }}>
                  {f}
                </Text>
              ))}
            </Space>
          ) : (
            '—'
          )}
        </Descriptions.Item>
        <Descriptions.Item label="拒绝时间">
          {dayjs(detail.rejectedAt).format('YYYY-MM-DD HH:mm:ss')}
        </Descriptions.Item>
        <Descriptions.Item label="Airwallex 单号">
          {shortReferenceId ?? '（没有单号：这笔请求没有被受理）'}
        </Descriptions.Item>
      </Descriptions>
      <CopyButton
        type="default"
        size="middle"
        label="复制原文"
        successMessage="已复制，可以直接贴给研发"
        text={JSON.stringify({ payoutId, shortReferenceId, ...detail }, null, 2)}
      />
    </>
  );
}
